/* firmanumre-oensk.js - /pages/oensk-et-nummer (templates/page.oensk.liquid)
   27. september 2026.

   - Otte felter pr. ønske, ét ciffer pr. felt, højst 4 cifre i alt,
     3. ciffer kan ikke være 0 (findes ikke i den danske nummerplan).
   - Hvert ønske kan få en form fra FORMER. Formens bogstaver vises som
     pladsholdere i felterne.
   - Ubegrænset antal ønsker.
   - Mens der skrives, vises ledige numre, der passer, fra søgeindekset.
     Cachen deles med firmanumre-soeg.js (localStorage fn_indeks_v1, samme
     format), så indekset kun hentes én gang.
   - Ønskerne samles i contact[Cifre] og gemmes i sessionStorage, så
     takkesiden kan gentage dem og vise numre, der ligner. */
(function () {
  'use strict';

  var MAKS_CIFRE = 4;
  var INDEKS_URL = '/collections/alle-guldnumre?view=fn-indeks&page=';
  var CACHE = 'fn_indeks_v1', CACHE_FRISK = 30 * 60 * 1000;
  var SENDT = 'fn_oensk_sendt';
  var VIS_MAKS = 40;

  /* Skabelon med otte tegn: ciffer = fast, * = hvad som helst,
     bogstav = variabel (samme bogstav = samme ciffer, forskellige bogstaver
     = forskellige cifre). ~ foran = må stå hvor som helst i nummeret.
     fri: bogstaverne må gerne være samme ciffer (7070 2020 er abab xyxy). */
  var FORMER = [
    { k: '', l: 'Ingen bestemt', e: 'alle former' },
    { k: 'abababab', l: 'ab ab ab ab', e: '70 70 70 70' },
    { k: 'ababxyxy', l: 'abab xyxy', e: '7070 2020', fri: true },
    { k: 'abcdabcd', l: 'abcd abcd', e: '7020 7020' },
    { k: 'aabbccdd', l: 'aa bb cc dd', e: '22 33 44 55' },
    { k: '**ababab', l: '•• ab ab ab', e: '50 20 20 20' },
    { k: '**abcabc', l: '•• abc abc', e: '22 722 722' },
    { k: '**aaabbb', l: '•• aaa bbb', e: '50 222 333' },
    { k: '~aaaa', l: '4 ens i træk', e: '50 55 55 20' },
    { k: '***0*0*0', l: '•• •0 •0 •0', e: '50 20 30 40' },
    { k: '*****000', l: 'Slutter på 000', e: '50 213 000' }
  ];
  function formFra(k) { for (var i = 0; i < FORMER.length; i++) if (FORMER[i].k === k) return FORMER[i]; return FORMER[0]; }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function kr(p) { return 'kr. ' + String(Math.round(p)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function laesJSON(n, lager) { try { return JSON.parse((lager || localStorage).getItem(n)); } catch (e) { return null; } }
  function skrivJSON(n, v, lager) { try { (lager || localStorage).setItem(n, JSON.stringify(v)); } catch (e) {} }

  /* ---------------------------------------------------------------- Indeks */
  var indeksLoefte = null;
  function hentIndeks() {
    if (indeksLoefte) return indeksLoefte;
    var c = laesJSON(CACHE);
    if (c && c.numre && Date.now() - (c.ts || 0) < CACHE_FRISK) return (indeksLoefte = Promise.resolve(c.numre));
    var net = fetch(INDEKS_URL + '1', { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      var loefter = [];
      for (var s = 2; s <= (d.sider || 1); s++) loefter.push(fetch(INDEKS_URL + s, { credentials: 'omit' }).then(function (r) { return r.json(); }));
      return Promise.all(loefter).then(function (rest) {
        var alle = d.numre || [];
        rest.forEach(function (x) { alle = alle.concat(x.numre || []); });
        skrivJSON(CACHE, { ts: Date.now(), antal: d.antal, numre: alle });
        return alle;
      });
    });
    /* En gammel cache er bedre end ingenting, hvis nettet fejler. */
    indeksLoefte = net['catch'](function () { return c && c.numre ? c.numre : []; });
    return indeksLoefte;
  }

  /* ---------------------------------------------------------------- Match */
  function formTest(k, n) { return formStart(k, n) > -1; }
  function formStart(k, n) {
    if (!k) return 0;
    var fri = !!formFra(k).fri;
    var flyd = k.charAt(0) === '~', t = flyd ? k.slice(1) : k;
    for (var s = 0; s + t.length <= n.length; s++) {
      var bind = {}, brugt = {}, ok = true;
      for (var i = 0; i < t.length && ok; i++) {
        var c = t.charAt(i), d = n.charAt(s + i);
        if (c === '*') continue;
        if (/\d/.test(c)) { ok = d === c; continue; }
        if (bind[c] === undefined) { if (brugt[d] && !fri) ok = false; else { bind[c] = d; brugt[d] = 1; } }
        else ok = bind[c] === d;
      }
      if (ok) return s;
      if (!flyd) return -1;
    }
    return -1;
  }
  /* De cifferpositioner (0-7), der skal fremhæves: faste cifre på rette plads
     og de pladser, formen binder. */
  function fremhaevPos(e, oe) {
    var pos = {};
    if (!oe) return pos;
    for (var i = 0; i < 8; i++) if (oe.cifre[i] && e.n.charAt(i) === oe.cifre[i]) pos[i] = 1;
    var ft = feltSkabelon(oe);
    if (ft && feltTest(oe, e.n)) for (var f = 0; f < 8; f++) if (ft.charAt(f) !== '*') pos[f] = 1;
    if (oe.form) {
      var st = formStart(oe.form, e.n), t = oe.form.charAt(0) === '~' ? oe.form.slice(1) : oe.form;
      if (st > -1) for (var j = 0; j < t.length; j++) if (t.charAt(j) !== '*') pos[st + j] = 1;
    }
    return pos;
  }
  /* Visningen (fx "70 70 00 30") med fremhævede cifre. Stregen lukkes ved
     mellemrum, så den ikke løber hen under hullerne mellem grupperne. */
  function fremhaev(v, pos) {
    var ud = '', aaben = false, d = 0;
    for (var i = 0; i < v.length; i++) {
      var c = v.charAt(i);
      if (!/\d/.test(c)) { if (aaben) { ud += '</em>'; aaben = false; } ud += esc(c); continue; }
      var hl = !!pos[d++];
      if (hl && !aaben) { ud += '<em class="fn-hl">'; aaben = true; }
      if (!hl && aaben) { ud += '</em>'; aaben = false; }
      ud += c;
    }
    return ud + (aaben ? '</em>' : '');
  }
  /* Bogstaver i felterne virker som en form: samme bogstav = samme ciffer,
     forskellige bogstaver = forskellige cifre. */
  function feltSkabelon(oe) { var t = oe.cifre.map(function (c) { return c || '*'; }).join(''); return /[a-z]/.test(t) ? t : ''; }
  function feltTest(oe, n) { var t = feltSkabelon(oe); return !t || formStart(t, n) === 0; }
  function passer(e, oe) {
    if (!e.a || !e.n || e.n.length !== 8) return false;
    for (var i = 0; i < 8; i++) if (/\d/.test(oe.cifre[i]) && e.n.charAt(i) !== oe.cifre[i]) return false;
    return feltTest(oe, e.n) && formTest(oe.form, e.n);
  }
  function harKrav(oe) { return !!oe.form || oe.cifre.some(function (c) { return !!c; }); }
  function find(numre, oe) {
    return numre.filter(function (e) { return passer(e, oe); }).sort(function (a, b) { return a.p - b.p; });
  }
  /* Takkesiden: præcise træf først, derefter numre der ligner
     (antal faste cifre på rette plads, formen, samme to første cifre). */
  function lignende(numre, oensker, antal) {
    var set = {}, ud = [];
    oensker.forEach(function (oe) {
      find(numre, oe).forEach(function (e) { if (!set[e.h]) { set[e.h] = 1; ud.push({ e: e, s: 100, oe: oe }); } });
    });
    if (ud.length < antal) {
      var kand = [];
      numre.forEach(function (e) {
        if (!e.a || set[e.h] || !e.n || e.n.length !== 8) return;
        var bedst = 0, bedstOe = null;
        oensker.forEach(function (oe) {
          var s = 0;
          for (var i = 0; i < 8; i++) if (oe.cifre[i] && e.n.charAt(i) === oe.cifre[i]) s += 2;
          if (oe.form && formTest(oe.form, e.n)) s += 3;
          if (feltSkabelon(oe) && feltTest(oe, e.n)) s += 3;
          if (s > bedst) { bedst = s; bedstOe = oe; }
        });
        if (bedst > 0) kand.push({ e: e, s: bedst, oe: bedstOe });
      });
      kand.sort(function (a, b) { return b.s - a.s || a.e.p - b.e.p; });
      ud = ud.concat(kand);
    }
    return ud.slice(0, antal);
  }

  function kortHtml(e, oe) {
    var type = e.t === 'fastnet' ? 'Fastnet' : e.t === '70' ? '70-nummer' : 'Mobil';
    return '<a class="fnoe__kort" href="/products/' + esc(e.h) + '" data-h="' + esc(e.h) + '" data-v="' + esc(e.v) + '">' +
      '<span class="fn-nrkort" aria-hidden="true"><span class="fn-nrkort__tal">' + fremhaev(e.v, fremhaevPos(e, oe)) + '</span></span>' +
      '<span class="fn-sr">' + esc(e.v) + '</span>' +
      '<span class="fnoe__kort-linje"><span class="fnoe__kort-pris">' + kr(e.p) + '</span><span class="fnoe__kort-type">' + type + '</span></span>' +
      '<span class="fnoe__kort-moms">ekskl. moms</span></a>';
  }
  /* Altid én række. Flere kort end der er plads til rulles vandret med
     snap; pilene vises kun på skærme med mus og kun når der er mere at se.
     Én række betyder fast højde, uanset antal træf. */
  function karussel(kort) {
    return '<div class="fnoe__karussel"><div class="fnoe__match-liste">' + kort.join('') + '</div>' +
      '<button type="button" class="fnoe__pil fnoe__pil--f" data-fnoe-pil="-1" aria-label="Forrige numre" hidden></button>' +
      '<button type="button" class="fnoe__pil fnoe__pil--n" data-fnoe-pil="1" aria-label="Næste numre" hidden></button></div>';
  }
  function skelet(n) { var k = []; for (var i = 0; i < n; i++) k.push('<span class="fnoe__kort fnoe__kort--skelet" aria-hidden="true"><span class="fn-nrkort"></span><span class="fnoe__kort-linje"><span class="fnoe__kort-pris">&nbsp;</span></span><span class="fnoe__kort-moms">&nbsp;</span></span>'); return karussel(k); }
  function pile(rod) {
    rod.querySelectorAll('.fnoe__karussel').forEach(function (k) {
      var l = k.querySelector('.fnoe__match-liste'), f = k.querySelector('.fnoe__pil--f'), n = k.querySelector('.fnoe__pil--n');
      var mere = l.scrollWidth - l.clientWidth > 2;
      f.hidden = !mere || l.scrollLeft < 4; n.hidden = !mere || l.scrollLeft > l.scrollWidth - l.clientWidth - 4;
      if (!l._bundet) { l._bundet = 1; l.addEventListener('scroll', function () { pile(k.parentNode); }, { passive: true }); }
    });
  }
  function bindPile(rod) {
    rod.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-fnoe-pil]'); if (!b) return;
      var l = b.parentNode.querySelector('.fnoe__match-liste');
      l.scrollBy({ left: +b.getAttribute('data-fnoe-pil') * l.clientWidth * 0.9, behavior: 'smooth' });
    });
  }

  /* Et almindeligt klik åbner preview-arket (Læg i kurv direkte).
     Cmd/Ctrl/Shift/midterklik følger linket. */
  function bindKort(rod) {
    rod.addEventListener('click', function (ev) {
      var a = ev.target.closest('.fnoe__kort'); if (!a) return;
      if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var fk = window.fnKort;
      if (fk && fk.aabnKig) { ev.preventDefault(); fk.aabnKig(a.getAttribute('data-h'), a.getAttribute('data-v')); }
    });
  }

  /* ---------------------------------------------------------------- Takkesiden */
  function takkeside() {
    var tak = document.querySelector('[data-fnoe-tak]'); if (!tak) return false;
    var gemt = laesJSON(SENDT, sessionStorage), oensker = gemt && gemt.oensker ? gemt.oensker : [];
    var oeEl = tak.querySelector('[data-fnoe-tak-oensker]');
    if (oensker.length) {
      oeEl.innerHTML = '<p class="fnoe__tak-lbl">' + (oensker.length === 1 ? 'Dit ønske' : 'Dine ønsker') + '</p><ul>' +
        oensker.map(function (oe) { return '<li>' + esc(oe.tekst) + '</li>'; }).join('') + '</ul>';
      oeEl.hidden = false;
    }
    var sek = document.querySelector('[data-fnoe-tak-numre]'), liste = sek.querySelector('[data-fnoe-tak-liste]');
    hentIndeks().then(function (numre) {
      var vis = oensker.length ? lignende(numre, oensker, 12) : [];
      if (!vis.length) {
        vis = numre.filter(function (e) { return e.a; }).slice(0, 12).map(function (e) { return { e: e }; });
        sek.querySelector('[data-fnoe-tak-numre-h]').textContent = 'Udvalgte ledige numre';
      }
      if (!vis.length) return;
      liste.innerHTML = karussel(vis.map(function (x) { return kortHtml(x.e, x.oe); }));
      sek.hidden = false; pile(sek);
    });
    bindKort(sek); bindPile(sek);
    return true;
  }

  /* ---------------------------------------------------------------- Formularen */
  function opsaet() {
    if (takkeside()) return;
    var form = document.getElementById('FnOenskForm'); if (!form) return;
    var raekker = form.querySelector('[data-fnoe-raekker]'), mere = form.querySelector('[data-fnoe-mere]'), samlet = form.querySelector('[data-fnoe-cifre]');
    var skabelon = raekker.querySelector('[data-fnoe-raekke]').cloneNode(true);

    function felter(r) { return Array.prototype.slice.call(r.querySelectorAll('input[data-plads]')); }
    /* Højst 4 udfyldte felter i alt - bogstaver tæller med (Richard 27.9). */
    function antal(r) { return felter(r).filter(function (f) { return f.value; }).length; }
    function oenske(r) { return { cifre: felter(r).map(function (f) { return f.value; }), form: r.getAttribute('data-form') || '' }; }
    function tekst(r) {
      var d = '', oe = oenske(r);
      oe.cifre.forEach(function (c, i) { d += (c || '•') + (i === 1 || i === 3 || i === 5 ? ' ' : ''); });
      return d + (oe.form ? ', form ' + formFra(oe.form).l : '');
    }

    function besked(r, t) {
      var ud = r.querySelector('[data-fnoe-laes]');
      ud.textContent = t; ud.classList.add('fnoe__laes--fejl');
      clearTimeout(r._besked); r._besked = setTimeout(function () { ud.classList.remove('fnoe__laes--fejl'); opdater(); }, 2200);
    }

    function laes(r) {
      var ud = r.querySelector('[data-fnoe-laes]'), n = antal(r);
      r.classList.toggle('fnoe__raekke--fuld', n >= MAKS_CIFRE);
      if (ud.classList.contains('fnoe__laes--fejl')) return;
      ud.innerHTML = '<span><b>' + n + '</b> af ' + MAKS_CIFRE + ' cifre</span>';
    }

    /* Formens bogstaver som pladsholdere, så formen kan ses i felterne. */
    function pladsholdere(r) {
      var k = r.getAttribute('data-form') || '', t = k.charAt(0) === '~' ? '' : k;
      felter(r).forEach(function (f, i) { var c = t.charAt(i); f.placeholder = !c || c === '*' ? '•' : c; });
    }

    /* Ét fælles forslagspanel under "Tilføj et ønske mere". Det viser forslag
       til det ønske, der sidst blev rørt. Panelet står der altid og har altid
       én række kort, så siden ikke hopper mens der skrives. */
    var box = form.querySelector('[data-fnoe-match]'), numre = null, aktiv = raekker.querySelector('[data-fnoe-raekke]');
    bindKort(box); bindPile(box);
    function tegnMatch() {
      var rk = Array.prototype.slice.call(raekker.querySelectorAll('[data-fnoe-raekke]'));
      if (rk.indexOf(aktiv) < 0) aktiv = rk[0];
      var nr = rk.indexOf(aktiv) + 1, oe = oenske(aktiv), h, kort;
      var lbl = rk.length > 1 ? 'Forslag til ønske ' + nr : 'Forslag';
      if (!numre) { box.innerHTML = '<p class="fnoe__forslag">' + lbl + '</p><p class="fnoe__match-h">Henter ledige numre …</p>' + skelet(4); return; }
      var udvalgte = function () { return numre.filter(function (e) { return e.a; }).slice(0, 12).map(function (e) { return kortHtml(e); }); };
      if (!harKrav(oe)) {
        h = 'Udvalgte ledige numre';
        kort = udvalgte();
      } else {
        var hit = find(numre, oe);
        if (hit.length) {
          h = '<strong>' + hit.length + (hit.length === 1 ? ' ledigt nummer passer' : ' ledige numre passer') + '</strong> - kan købes nu';
          kort = hit.slice(0, VIS_MAKS).map(function (e) { return kortHtml(e, oe); });
        } else {
          var naer = lignende(numre, [oe], 12);
          if (naer.length) {
            h = '<span class="fnoe__match-tom">Intet passer præcist</span> - tættest på';
            kort = naer.map(function (x) { return kortHtml(x.e, x.oe); });
          } else {
            h = '<span class="fnoe__match-tom">Intet passer præcist</span> - udvalgte ledige numre';
            kort = udvalgte();
          }
        }
      }
      box.innerHTML = '<p class="fnoe__forslag">' + lbl + '</p><p class="fnoe__match-h">' + h + '</p>' + (kort.length ? karussel(kort) : skelet(0));
      pile(box);
    }
    hentIndeks().then(function (x) { numre = x; tegnMatch(); });

    function opdater() {
      var rk = raekker.querySelectorAll('[data-fnoe-raekke]'), alle = [];
      rk.forEach(function (r, i) {
        laes(r);
        r.querySelector('[data-fnoe-nr]').textContent = 'Ønske ' + (i + 1);
        if (harKrav(oenske(r))) alle.push('Ønske ' + (i + 1) + ': ' + tekst(r));
      });
      samlet.value = alle.join(' | ');
      tegnMatch();
    }

    /* Ét ciffer pr. felt. Et nyt ciffer i et udfyldt felt erstatter det gamle. */
    function saet(r, inp, v) {
      var gl = inp.getAttribute('data-v') || '';
      if (inp.getAttribute('data-plads') === '3' && v === '0') { inp.value = gl; return '3. ciffer kan ikke være 0.'; }
      if (v && !gl && antal(r) >= MAKS_CIFRE) { inp.value = gl; return 'Højst 4 cifre i alt.'; }
      inp.value = v; inp.setAttribute('data-v', v);
      return '';
    }

    /* Mobilens taltastatur har ingen bogstaver. Knappen skifter rækkens felter
       mellem taltastatur og bogstavtastatur; iOS skifter først ved nyt fokus. */
    function tastatur(r, bogstaver) {
      var knap = r.querySelector('[data-fnoe-tast]');
      felter(r).forEach(function (f) {
        f.setAttribute('inputmode', bogstaver ? 'text' : 'numeric');
        if (bogstaver) f.removeAttribute('pattern'); else f.setAttribute('pattern', '[0-9]*');
      });
      knap.textContent = bogstaver ? '123' : 'abc';
      knap.setAttribute('aria-label', bogstaver ? 'Skriv cifre' : 'Skriv bogstaver');
      knap.setAttribute('aria-pressed', bogstaver ? 'true' : 'false');
    }

    function bind(r) {
      var alle = felter(r);
      var knap = r.querySelector('[data-fnoe-tast]');
      knap.addEventListener('pointerdown', function (e) { e.preventDefault(); });
      knap.addEventListener('click', function () {
        var ny = knap.getAttribute('aria-pressed') !== 'true', aktiv = document.activeElement;
        tastatur(r, ny);
        var f = alle.indexOf(aktiv) > -1 ? aktiv : alle.filter(function (x) { return !x.value; })[0] || alle[0];
        f.blur(); setTimeout(function () { f.focus(); }, 30);
      });
      r.addEventListener('focusin', function () { if (aktiv !== r) { aktiv = r; tegnMatch(); } });
      alle.forEach(function (inp, idx) {
        /* Markér indholdet, så et nyt ciffer erstatter det gamle. KUN hvis feltet
           stadig har fokus: select() flytter fokus i Chrome, og en forsinket
           select() på det forrige felt gav en uendelig fokusløkke (målt). */
        inp.addEventListener('focus', function () { setTimeout(function () { if (document.activeElement === inp) try { inp.select(); } catch (e) {} }, 0); });
        /* Var feltets indhold markeret, erstatter tastetrykket det. Stod markøren
           bare efter tegnet, er det et nyt tegn - og det tæller mod de 4. */
        inp.addEventListener('beforeinput', function () { inp._erstat = inp.selectionStart !== inp.selectionEnd; });
        inp.addEventListener('input', function () {
          var raa = inp.value.toLowerCase().replace(/[^0-9a-z]/g, ''), gl = inp.getAttribute('data-v') || '';
          if (raa.length > 1 && gl && !inp._erstat && antal(r) >= MAKS_CIFRE) { inp.value = gl; besked(r, 'Højst 4 cifre i alt.'); return; }
          var v = raa.length > 1 ? (raa.replace(gl, '') || raa).slice(-1) : raa;
          inp.value = gl; /* antal() skal tælle det gamle, ikke det rå input */
          var fejl = saet(r, inp, v);
          opdater(); if (fejl) besked(r, fejl);
          if (v && !fejl && antal(r) < MAKS_CIFRE && alle[idx + 1]) alle[idx + 1].focus();
        });
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !inp.value && alle[idx - 1]) { alle[idx - 1].focus(); e.preventDefault(); }
          else if (e.key === 'ArrowLeft' && alle[idx - 1]) { alle[idx - 1].focus(); e.preventDefault(); }
          else if (e.key === 'ArrowRight' && alle[idx + 1]) { alle[idx + 1].focus(); e.preventDefault(); }
        });
        /* Et helt nummer indsat i ét felt fordeles ét tegn pr. felt, højst 4 i alt.
           Bogstaver bevares (abab xyxy); ?, *, _ og . = hvad som helst. */
        inp.addEventListener('paste', function (e) {
          var t = ((e.clipboardData || window.clipboardData).getData('text') || '').replace(/^\s*(\+45|0045)/, '');
          var tegn = t.toLowerCase().replace(/[^\da-z?*_.]/g, '').split('');
          if (tegn.length < 2) return;
          e.preventDefault();
          for (var j = idx; j < alle.length; j++) { alle[j].value = ''; alle[j].setAttribute('data-v', ''); }
          var fejl = '', sidst = idx;
          for (var k = 0; k < tegn.length && idx + k < alle.length; k++) {
            fejl = saet(r, alle[idx + k], /[\da-z]/.test(tegn[k]) ? tegn[k] : '') || fejl; sidst = idx + k;
          }
          opdater(); if (fejl) besked(r, fejl);
          (alle[sidst + 1] || alle[sidst]).focus();
        });
      });
    }

    bind(raekker.querySelector('[data-fnoe-raekke]'));
    mere.addEventListener('click', function () {
      var ny = skabelon.cloneNode(true);
      var fjern = document.createElement('button'); fjern.type = 'button'; fjern.className = 'fnoe__fjern'; fjern.textContent = 'Fjern'; fjern.setAttribute('aria-label', 'Fjern dette ønske');
      fjern.addEventListener('click', function () { ny.remove(); opdater(); mere.focus(); });
      ny.querySelector('.fnoe__raekke-knapper').appendChild(fjern);
      raekker.appendChild(ny); bind(ny); opdater();
      ny.querySelector('input').focus();
    });

    form.addEventListener('submit', function () {
      opdater();
      var gem = [];
      raekker.querySelectorAll('[data-fnoe-raekke]').forEach(function (r) {
        var oe = oenske(r);
        if (harKrav(oe)) { oe.tekst = tekst(r); gem.push(oe); }
      });
      skrivJSON(SENDT, { ts: Date.now(), oensker: gem }, sessionStorage);
    });

    var m = /[?&]q=([^&]*)/.exec(window.location.search), besk = form.querySelector('[data-fnoe-besk]');
    if (m && besk && !besk.value) { var q = decodeURIComponent(m[1].replace(/\+/g, ' ')).replace(/[^\d\s*?a-z]/gi, '').trim(); if (q) besk.value = 'Skal indeholde ' + q + '.'; }
    opdater();
  }

  window.addEventListener('resize', function () { pile(document); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', opsaet);
  else opsaet();

  window.fnOensk = { FORMER: FORMER, formTest: formTest, fremhaev: fremhaev, fremhaevPos: fremhaevPos, passer: passer, lignende: lignende, hent: hentIndeks };
})();
